<template>
  <div class="multiLabel">
    <color-label
      :style="{ marginRight: overlapMarginEm + 'em' }"
      :class="singleLabelClass"
      :color="color"
      :key="index"
      :size="size"
      v-for="(color, index) in colorsInReversedOrder"
    />
  </div>
</template>

<style lang="scss" scoped>
.multiLabel {
  display: flex;
  flex-direction: row-reverse;
  //overflow: hidden;
}

.separate {
  margin-right: 0.1em !important;
}

.overlap {
  float: left;
  position: relative;
  overflow: hidden;
}
</style>

<script>
// @flow
import _ from 'lodash'
import ColorLabel from './ColorLabel'

export default {
  name: 'multi-color-label',
  components: { ColorLabel },
  props: {
    size: String,
    colors: Array
  },

  methods: {
    toHue(hexColor) {
      if (!hexColor) return 0

      const hex = hexColor.replace('#', '')
      let r = parseInt(hex.substring(0, 2), 16)
      let g = parseInt(hex.substring(2, 4), 16)
      let b = parseInt(hex.substring(4, 6), 16)

      // Courtesy of https://stackoverflow.com/questions/39118528/rgb-to-hsl-conversion
      r /= 255
      g /= 255
      b /= 255
      var max = Math.max(r, g, b)
      var min = Math.min(r, g, b)
      var c = max - min
      var hue
      if (c == 0) {
        hue = 0
      } else {
        switch (max) {
          case r:
            var segment = (g - b) / c
            var shift = 0 / 60 // R° / (360° / hex sides)
            if (segment < 0) {
              // hue > 180, full rotation
              shift = 360 / 60 // R° / (360° / hex sides)
            }
            hue = segment + shift
            break
          case g:
            var segment = (b - r) / c
            var shift = 120 / 60 // G° / (360° / hex sides)
            hue = segment + shift
            break
          case b:
            var segment = (r - g) / c
            var shift = 240 / 60 // B° / (360° / hex sides)
            hue = segment + shift
            break
        }
      }
      return hue * 60 // hue is in [0,6], scale it up
    }
  },

  computed: {
    overlapMarginEm() {
      if (this.labelsShouldOverlap) {
        return -this.colors.length / (this.colors.length + 10)
      }
      return 0
    },
    colorsInReversedOrder() {
      return _.reverse(_.sortBy(this.colors, this.toHue))
    },
    labelsShouldOverlap() {
      return this.colors.length > 5
    },
    singleLabelClass() {
      return this.labelsShouldOverlap ? 'overlap' : 'separate'
    }
  }
}
</script>
